import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'
import { exportCards } from '../constants/exportCards'
import { ExportCardVisibilityConditions } from '../utils/exportsCardVisibilityRules'
import { isExportCardVisible } from '../utils/isExportCardVisible'

const UNSUPPORTED_SAFT_COUNTRIES = ['DE', 'FR', 'NL']

export const useVisibleExportsCards = () => {
  const { organization } = useUserOrganization()
  const isProductAuthorized = isAuthorized(Scope.ProductWrite)
  const isReportsReadAuthorized = isAuthorized(Scope.ReportsRead)

  const isFECReportEnabled = organization?.countryId === 'FR' && isReportsReadAuthorized
  const isSAFTExportEnabled = !!organization?.countryId && !UNSUPPORTED_SAFT_COUNTRIES.includes(organization.countryId)
  const isXAFExportEnabled = organization?.countryId === 'NL' && isReportsReadAuthorized
  // Product/item export is available for all sources (incl. Zervant). Zervant items are exported
  // client-side from /v4/products, Billy items via the legacy v2 export endpoint (see the Products export card).
  const isProductExportEnabled = isProductAuthorized

  const exportCardVisibilityConditions: ExportCardVisibilityConditions = useMemo(() => {
    return {
      isFECReportEnabled,
      isXAFExportEnabled,
      isSAFTExportEnabled,
      isProductExportEnabled,
      isReportsReadAuthorized,
    }
  }, [isFECReportEnabled, isXAFExportEnabled, isSAFTExportEnabled, isProductExportEnabled, isReportsReadAuthorized])

  const visibleCards = useMemo(() => {
    return exportCards.filter(({ id }) => isExportCardVisible({ exportCardVisibilityConditions, id }))
  }, [exportCardVisibilityConditions])

  return { visibleCards }
}
